/* used to export colors used in the scss file */

export const royalBlue = "#2072E6";
export const red = "#e63120";
export const hawkesBlue = "#dfe1e6";
export const tuna = "#45484D";
export const manatee = "#8F9299";
export const blackPearl = "#1b2026";
export const white = "#ffffff";
